import styled from "styled-components";
import { motion } from "framer-motion";

export const BodyContainerMotion = styled(motion.div)`
  display: flex;
  width: 100%;
  height: calc(100% - 70px);
  @media (max-width: 1279px) {
    height: calc(100% - 30vh);
  }
  /* Let's get this party started */
  ::-webkit-scrollbar {
    width: 8px;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--color-scrollbar);
  }
  ::-webkit-scrollbar-thumb:hover {
    background: var(--color-latex10);
  }

  @media (max-width: 768px) {
    /* Let's get this party started */
    ::-webkit-scrollbar {
      width: 0;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: var(--color-scrollbar);
    }
    ::-webkit-scrollbar-thumb:hover {
      background: var(--color-latex10);
    }
  }
`;

export const MotionContainerScroll = styled(motion.div)`
  width: 100%;
  height: 100%;
  padding: 40px 20px;
  display: flex;
  gap: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const MobileBuscador = styled.div`
  margin: auto;
  width: 400px;
  height: 360px;
  border-radius: 8px;
  background: var(--color-buscadorCards-gradient);
  box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.02),
    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.03),
    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.04),
    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.04),
    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.05),
    0px 100px 80px 0px rgba(0, 0, 0, 0.07);
  display: none;
  gap: 20px;
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 500px) {
    text-align: center;
    width: 90%;
    padding: 0 10px;
  }
`;

export const BtnBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px;
  justify-content: center;
  align-items: center;
`;

export const BtnOpcContainer = styled.div`
  width: 170px;
  padding: 4px 8px;
  height: 46px;
  border-radius: 8px;
  background: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;

`;

export const BoxSaludoBuscador = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
`;

export const BoxSaludoPresentismo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
`;
export const BoxBuscadorLineaContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
  margin-left: 30px;
  ${({ $pasos }) => {
    if ($pasos === 2) {
      return `padding-bottom: 250px;`;
    } else if ($pasos === 3) {
      return `padding-bottom: 0px;`;
    }
  }}
  @media (max-width: 1280px) {
    margin-left: 0px;
    ${({ $pasos }) => {
      if ($pasos === 2) {
        return `padding-bottom: 150px;`;
      } else if ($pasos === 3) {
        return `padding-bottom: 0px;`;
      }
    }}
  }
  /* padding-bottom: 200px; */
`;
